<div class="ftu-form " *ngIf="!authService?.FTUPanelData?.Validation && !rootScope.activeCustTab.otcInsideFTU.hasAccountBalance ">
    <div *ngIf="showFTUErr() && !rootScope.activeCustTab.IS_AAAS_ENABLED" class="error-wrapper">
        <f-alert variant="error">{{errorMessage}}
            <span *ngIf="authService.FTUPanelData?.APIFailure">
                <button (click)="authService.getFTUCredential()" class="btn-alert">Try again</button>
            </span>
        </f-alert>
    </div>
    <p *ngIf="!showValidtionInfo()">Enter all information below, then click Validate. </p>
    <div class="container validation-method">
        <!-- <form [formGroup]="authService.ftuPanelForm" *ngIf="!rootScope.activeCustTab.IS_AAAS_ENABLED">
            <span *ngFor="let group of authService?.FTUPanelData?.FTUContent">
              
                <span *ngFor="let subgroup of group.subgroups">
                 
                    <span *ngFor="let section of subgroup.sections">
                    

                        <span *ngFor="let subgroup of section.sectionsubgroups">
                          

                            <div class="row row-top-margin" *ngFor="let element of subgroup.elements">
                                <div class="col-md-6 single-col">
                                    <mat-form-field *ngIf="(element.title !== 'DOB'&& element.title !== 'HIREDATE')"
                                        appearance="fill" class="component-box">
                                        <mat-label>{{element.key}}</mat-label>
                                        <ng-container *ngIf="element.title==='LAST4SSN'">
                                            <input matInput [id]="element.key" [formControlName]="element.key"
                                                appAutoCompleteOff [maxlength]="4" />
                                        </ng-container>
                                        <ng-container *ngIf="element.title !=='LAST4SSN'">
                                            <input matInput [id]="element.key" [formControlName]="element.key"
                                                appAutoCompleteOff />
                                        </ng-container>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="element.title === 'HIREDATE'" appearance="fill"
                                        class="component-box">
                                        <mat-label>{{element.key}}</mat-label>
                                        <input matInput [id]="element.key" [formControlName]="element.key"
                                            appAutoCompleteOff />
                                        <mat-error *ngIf="errorHandling(element)">
                                            <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
                                            {{ errorHandling(element)}}
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="element.title === 'DOB'" appearance="fill"
                                        class="component-box">
                                        <mat-label>{{element.key}}</mat-label>
                                        <input matInput [id]="element.key" appAutoCompleteOff [max]="maxDate"
                                            [formControlName]="element.key" [matDatepicker]="picker1" />
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1></mat-datepicker>
                                        <mat-error *ngIf="errorHandling(element)">
                                            <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
                                            {{ errorHandling(element)}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div *ngIf="element.title === 'FULLNAME'" class="col-md-6">
                                    <mat-checkbox [formControlName]="'additionalCheckboxKey'" color="primary" class="verify-checkbox">
                                        The customer’s name is verified.</mat-checkbox>
                                </div>

                                <div *ngIf="authService.checkIVRConfirmation(section)" class="col-md-6 ivrCheck">
                                    <span class="data-verified"><f-icon icon-config='{"iconName": "circle-check", "iconType": "light", "iconSize": "s"}'></f-icon> Confirmed via
                                        IVR</span>
                                </div>
                            </div>

                        </span>
                    </span>
                </span>
            </span>
            <div class="secondary-fields hide">
                <p class="row" >Validate additional fields to confirm the customer's identity.</p>
                <div class="row row-top-margin">
                    <div class="col-md-6  single-col">
                      <mat-form-field appearance="fill" class="component-box date-field">
                        <mat-label>Hire Date</mat-label>
                        <input matInput id="hiredate" value="" />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row row-top-margin">
                    <div class="col-md-6  single-col">
                      <mat-form-field appearance="fill" class="component-box date-field">
                        <mat-label>Employer ID</mat-label>
                        <input matInput id="empId" value="" />
                      </mat-form-field>
                    </div>
                  </div>
            </div>
           
            <div class="row footer-btn" *ngIf="authService?.FTUPanelData?.FTUContent">
                <div class="col-md-12">
                    <f-button text="Cancel" title="Cancel" [disabled]="false" (buttonClicked)="authService.resetFTUform()"
                        type="button" variant="action"></f-button>
                    <f-button text="Validate" title="Validate" [disabled]="disableSubmit()" (buttonClicked)="authService.onSubmit()"
                        type="button" variant="progressive">
                    </f-button>
                </div>
            </div>
        </form> -->

        <!--Sample form AaaS-->
        <!-- <form class="hide1"  [formGroup]="aaaSService.AaaSForm"  *ngIf="rootScope.activeCustTab.IS_AAAS_ENABLED">
           
                <ng-container *ngFor="let field of aaaSService.AaaSFieldListData?.[rootScope.activeCustTab.clientId]?.ftuIdentityProvidersList
                ">
                 <div class="row row-bottom-space">
                 <div class="col-md-6 single-col padding-0">
                 
                     <mat-form-field appearance="fill" class="component-box" *ngIf="field.fieldType === 'string'">
                              <mat-label>{{field.fieldLabel}}</mat-label>
                              <input matInput [id]="field.fieldName" value="" [formControlName]="field.fieldName" appAutoCompleteOff />
                            </mat-form-field>

                            <mat-form-field *ngIf="field.fieldType === 'date'" appearance="fill"
                            class="component-box">
                            <mat-label>{{field.fieldLabel}}</mat-label>
                            <input matInput [id]="field.fieldName" appAutoCompleteOff [max]="maxDate"
                                [formControlName]="field.fieldName" [matDatepicker]="picker2" />
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                           
                        </mat-form-field>      
                    
                </div>             
            </div>
            </ng-container>
       
            <div class="row footer-btn" >
                <div class="col-md-12">
                    <f-button text="Cancel" title="Cancel" [disabled]="false" (buttonClicked)="aaaSService.resetAaaSForm()"
                        type="button" variant="action"></f-button>
                    <f-button text="Validate" title="Validate" [disabled]="false" (buttonClicked)="aaaSService.onSubmit()"
                        type="button" variant="progressive">
                    </f-button>
                </div>
            </div>
        </form> -->
         <!-- CCR3-15080 Multiple Credential options in FTU -->
        <!-- <form class="hide">
             <p><strong>Name Validation</strong></p>
               <div class="row row-bottom-margin">
                           <div class="custom-text-width">
                             <mat-form-field  appearance="fill" class="component-box">
                               <mat-label>First and Last Name</mat-label>
                               <input matInput appAutoCompleteOff />
                             </mat-form-field>
                           </div>
                           <div class="verify-col">
                             <mat-checkbox  color="primary" class="verify-checkbox">
                               The customer’s name is verified.</mat-checkbox>
                           </div>

                           <div  class="col-md-6 hide">
                             <span class="data-verified "><f-icon icon-config='{"iconName": "circle-check", "iconType": "light", "iconSize": "s"}'></f-icon> Confirmed via
                               IVR</span>
                           </div>
            </div>
            <p><strong>Date Validation</strong></p>
             <mat-radio-group color="primary" class="account-selection custom-radio-selection row-bottom-margin" disableRipple aria-label="Select an option" [(ngModel)]="selectedDateValidation">
            <div class="row">
                
                <div>
                    <mat-radio-button class="custom-radio-width" value="dob">
                    <mat-form-field appearance="fill" class="component-box">
                        <mat-label>Date of Birth (MM/DD/YYYY)</mat-label>
                        <input matInput [max]="maxDate" id="dob" appAutoCompleteOff
                            formControlName="dob" [matDatepicker]="picker1" />
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                        
                    </mat-form-field>
                </mat-radio-button>
           
                </div>
                <div>
                    <span class="data-verified "><f-icon
                            icon-config='{"iconName": "circle-check", "iconType": "light", "iconSize": "s"}'></f-icon> Confirmed via
                        IVR</span>
                </div>
            </div>
            <div class="row row-top-margin row-bottom-margin">
                    <div>
                       
                    <mat-radio-button class="custom-radio-width " value="hiredate">
                      <mat-form-field appearance="fill" class="component-box date-field">
                        <mat-label>Hire Date (MM/YYYY)</mat-label>
                        <input matInput id="hiredate" value="" />
                      </mat-form-field>
                       </mat-radio-button>
           
                    </div>
                  </div>
            </mat-radio-group>

             <p><strong>Identifier Validation</strong></p>
             <mat-radio-group color="primary" class="account-selection custom-radio-selection" disableRipple aria-label="Select an option" [(ngModel)]="selectedIdentifierValidation">
            <div class="row">
                
                <div>
                    <mat-radio-button class="custom-radio-width" value="nationalId">
                     <mat-form-field appearance="fill" class="component-box date-field">
                        <mat-label>Last 4 of National ID</mat-label>
                        <input matInput id="nationalId" value="" />
                      </mat-form-field>
                </mat-radio-button>
           
                </div>
            </div>
            <div class="row row-top-margin row-bottom-margin">
                    <div>
                       
                    <mat-radio-button class="custom-radio-width" value="eeid">
                      <mat-form-field appearance="fill" class="component-box date-field">
                        <mat-label>Employee ID (EEID)</mat-label>
                        <input matInput id="eeid" value="" />
                      </mat-form-field>
                       </mat-radio-button>
           
                    </div>
                  </div>
            </mat-radio-group>

             <p><strong>Location Validation</strong></p>
             <mat-radio-group color="primary" class="account-selection custom-radio-selection row-bottom-margin" disableRipple aria-label="Select an option" [(ngModel)]="selectedIdentifierValidation">
            <div class="row">
                
                <div>
                    <mat-radio-button class="custom-radio-width" value="postalCode">
                     <mat-form-field appearance="fill" class="component-box date-field">
                        <mat-label>Postal Code</mat-label>
                        <input matInput id="postalCode" value="" />
                      </mat-form-field>
                </mat-radio-button>
           
                </div>
            </div>
            <div class="row row-bottom-margin">
                 <mat-radio-button class="custom-radiotextarea-width" value="postalAddress">
                           <div class="">
                              <f-textarea
                                [value]="'149 Sulphur Springs Road\nUpper Darby\nPA 19082'"
                                [disabled]="true">
                              </f-textarea>
                           </div>
                           </mat-radio-button>
                           <div class="verify-col">
                             <mat-checkbox  class="verify-checkbox">
                             The customer’s address is verified.</mat-checkbox>
                           </div>

                           <div  class="col-md-6 hide">
                             <span class="data-verified "><f-icon icon-config='{"iconName": "circle-check", "iconType": "light", "iconSize": "s"}'></f-icon> Confirmed via
                               IVR</span>
                           </div>
            </div>
            </mat-radio-group>

            <div class="row footer-btn">
                <div class="col-md-12">
                    <f-button text="Cancel" title="Cancel" [disabled]="true" 
                        type="button" variant="action"></f-button>
                    <f-button text="Validate" title="Validate" [disabled]="true"
                        type="button" variant="progressive">
                    </f-button>
                </div>
            </div>
             <div>  <strong>Note: </strong> If the FTU process cannot be completed at any stage, proceed with PIN Reset.</div>
        </form> -->
   <!-- starting of CCR3-14937 grouping of Credential options in FTU -->
        <div *ngIf="!hasGroupWithNoData" class="error-wrapper">
            <f-alert variant="info">
                Identification options are displayed in groups. Only one option per group is required for successful
                authentication. Disabled options indicate they are not available for the caller.
            </f-alert>
        </div>        
        <div *ngIf="hasGroupWithNoData"  class="error-wrapper">
            <f-alert variant="error">
                One or more values are missing, so the caller cannot be authenticated. Follow your team’s process for updating
                customer data.
            </f-alert>
        </div>
<form class="new ftu-selection-form" [formGroup]="authService.newFTUForm" *ngIf="!rootScope.activeCustTab.IS_AAAS_ENABLED">
    <section class="ftu-validation-group" *ngFor="let validationGroup of ftuValidationGroups; trackBy: trackByValidationGroup">
        <p class="validation-group-heading"><strong>{{ validationGroup.key }}</strong></p>
        <div *ngIf="validationGroup.key === 'Name Validation'" class="validation-option name-option">
            <div class="custom-text-width">
                <mat-form-field appearance="fill" class="component-box" hideRequiredMarker>
                    <mat-label>{{ validationGroup.value[0].label }}</mat-label>
                    <input matInput type="text" [formControlName]="validationGroup.value[0].sectionId"
                        [id]="validationGroup.value[0].sectionId" appAutoCompleteOff
                        (focus)="selectValidationOnFocus(validationGroup.key, validationGroup.value[0].sectionId)" />
                </mat-form-field>
            </div>
            <div class="verify-col">
                <mat-checkbox color="primary" class="verify-checkbox" formControlName="nameVerified">This customer’s
                    name is verified.</mat-checkbox>
            </div>
        </div>
        <ng-container *ngIf="validationGroup.key !== 'Name Validation'">
            <div class="validation-option"
                *ngFor="let field of validationGroup.value; trackBy: trackByValidationField">
                <mat-radio-button *ngIf="validationGroup.value.length > 1" color="primary" class="custom-radio-width"
                    [name]="'ftu-' + validationGroup.key" [value]="field.sectionId"
                                        [disabled]="authService.newFTUForm.get(field.sectionId)?.disabled"
                    [checked]="(validationGroup.key === 'Date Validation' ? selectedDateValidation : validationGroup.key === 'Identifier Validation' ? selectedIdentifierValidation : selectedLocationValidation) === field.sectionId"
                    [aria-label]="field.label"
                    (change)="onValidationChange(validationGroup.key, $event.value)"></mat-radio-button>
                <mat-form-field *ngIf="field.type === 'TEXT'" appearance="fill" class="component-box" hideRequiredMarker>
                    <mat-label>{{ field.label }}</mat-label>
                    <input matInput type="text" [formControlName]="field.sectionId"
                        [id]="field.sectionId" appAutoCompleteOff
                        (focus)="selectValidationOnFocus(validationGroup.key, field.sectionId)"
                        [attr.maxlength]=" field.sectionId === 'SEC-FTU-ACH-SSN' ? 4 : null" />
                </mat-form-field>
                <div *ngIf="field.type === 'DATE'" class="date-validation-field">
                    <mat-form-field appearance="fill" class="component-box" hideRequiredMarker>
                        <mat-label>{{ field.label }}</mat-label>
                        <input matInput [id]="field.sectionId" [formControlName]="field.sectionId" appAutoCompleteOff
                            [appFtuDateFormat]="field.stylekey || field.label"
                            [matDatepicker]="picker3" [max]="maxDate"
                            (focus)="selectValidationOnFocus(validationGroup.key, field.sectionId)"
                            (dateChange)="selectValidationOnFocus(validationGroup.key, field.sectionId)" />
                        <mat-datepicker-toggle matSuffix [for]="picker3"
                            (click)="selectValidationOnFocus(validationGroup.key, field.sectionId)"></mat-datepicker-toggle>
                        <mat-datepicker #picker3></mat-datepicker>
                    </mat-form-field>
                    <div *ngIf="authService.newFTUForm.get(field.sectionId)?.hasError('matDatepickerParse')" class="date-validation-error" role="alert">
                        Invalid date format.
                    </div>
                    <div *ngIf="authService.newFTUForm.get(field.sectionId)?.hasError('matDatepickerMax')" class="date-validation-error" role="alert">
                        Date of {{ field.sectionId === 'SEC-FTU-DOB' ? 'Birth' : 'Hire' }} cannot be a future date.
                    </div>
                </div>
                <f-textarea *ngIf="field.sectionId === 'SEC-FTU-PSTL-ADDR-GP'" [formControlName]="field.sectionId"
                    (focus)="selectValidationOnFocus(validationGroup.key, field.sectionId)"></f-textarea>
                <div *ngIf="field.sectionId === 'SEC-FTU-PSTL-ADDR-GP'" class="verify-col">
                    <mat-checkbox color="primary" class="verify-checkbox" formControlName="addressVerified">The
                        customer’s address is verified.</mat-checkbox>
                </div>
            </div>
        </ng-container>

    </section>
    <div class="row footer-btn">
        <div class="col-md-12">
            <f-button text="Cancel" title="Cancel" [disabled]="false" type="button" variant="action"></f-button>
            <f-button text="Validate" title="Validate" [disabled]="!isNewFTUFormValid()" type="button"
                variant="progressive" (buttonClicked)="authService.onSubmitNewFTUForm()"></f-button>
        </div>
    </div>
    <p class="ftu-form-note"><strong>Note:</strong> If the FTU process cannot be completed at any stage, proceed with
        PIN Reset.</p>
</form>
    <!-- ending of CCR3-14937 grouping of Credential options in FTU -->
   
    </div>
</div>
<div class="ftu-in-otc hide1" *ngIf="rootScope.activeCustTab.otcInsideFTU.hasAccountBalance && !rootScope.activeCustTab.otcInsideFTU.isOTCValidated">
    <f-alert class="error-with-heading alert-info" variant="info">
        <!--CCR3-11718 UI Issue fix class added-->
        <p class="alert-top-heading">Customer Data Validated</p>
        <p>Customer is required to complete the OTC process prior to PIN creation as an additional level of security.</p>
    </f-alert>

    <app-one-time-code></app-one-time-code>
</div>

<div class="ftu-steps-container" *ngIf="authService?.FTUPanelData?.Validation&& !rootScope.activeCustTab.isNoPINClient && (!rootScope.activeCustTab.otcInsideFTU.hasAccountBalance || rootScope.activeCustTab.otcInsideFTU.isOTCValidated) ">

    <f-alert class="error-with-heading alert-info " variant="info">
        <p class="alert-top-heading">Customer Data Validated</p>
        <p>The customer must create a PIN to complete the FTU flow.</p>
    </f-alert>

    <div class="step-container flex justify-space-between">
        <!-- step-1 -->
        <span class="step-val "
            [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step1Active || rootScope.activeCustTab.pinEntryApp?.step1Complete }">
            <span class="step-circle "
                [ngClass]="rootScope.activeCustTab.pinEntryApp?.step1Active? 'active' : 'complete'">
                <span *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Complete"> <f-icon
                        icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span>
                <span class="step-no" *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active">1</span>
            </span>Go to ALIS</span>
        <!-- step-2 -->
        <span class="step-val"
            [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step2Active || rootScope.activeCustTab.pinEntryApp?.step2Complete }">
            <span class="step-circle"
                [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step2Active,'complete': rootScope.activeCustTab.pinEntryApp?.step2Complete }">
                <span *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Complete"> <f-icon
                        icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon></span>
                <span class="step-no" *ngIf="!rootScope.activeCustTab.pinEntryApp?.step2Complete">2</span>
            </span>Transfer the call</span>
        <!-- step-3 -->
        <span class="step-val"
            [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step3Active || rootScope.activeCustTab.pinEntryApp?.step3Complete||rootScope.activeCustTab.pinEntryApp?.pinError }">
            <span class="step-circle"
                [ngClass]="{ 'active' :rootScope.activeCustTab.pinEntryApp?.step3Active,'complete': rootScope.activeCustTab.pinEntryApp?.step3Complete,'failure': rootScope.activeCustTab.pinEntryApp?.pinError }">
                <span
                    *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Complete||rootScope.activeCustTab.pinEntryApp?.pinError">
                    <f-icon [iconConfig]="{iconName: rootScope.activeCustTab.pinEntryApp?.step3Complete ? 'check' : 'xmark', iconType: 'solid', iconSize: 's'}"></f-icon></span>
                <span class="step-no"
                    *ngIf="!rootScope.activeCustTab.pinEntryApp?.step3Complete&&!rootScope.activeCustTab.pinEntryApp?.pinError">3</span>
            </span>Resume conversation</span>
    </div>
    <!-- For step-1 content  -- Pin Creation without language selection -->
    <p class="steps-content step1-content"
        *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active && !(languages?.length > 1)">
        Go to ALIS to transfer the customer to the PIN Entry App to create a PIN.
    </p>
    <!-- For step-1 content -- Pin creation with language selection -->
    <p class="steps-content step1-content"
        *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active && languages?.length > 1">
        Select the language for the PIN Entry App. Then, press the Create PIN button and go to ALIS to transfer the
        customer to PIN Entry App to create a PIN.
    </p>
    <mat-radio-group *ngIf="languages?.length > 1 && rootScope.activeCustTab.pinEntryApp?.step1Active" color="primary"
        class="account-selection" disableRipple aria-label="Select an option"
        [(ngModel)]="rootScope.activeCustTab.selectedAlisLang" (change)="onRadioChange($event.value)">
        <mat-radio-button class="delivery-method-button" *ngFor="let language of languages" [value]="language.code">
            {{language.label}}
        </mat-radio-button>
    </mat-radio-group>

    <!-- For step-2 content -->
    <p class="pin-content step2-content hide1" *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Active">
        The customer will be transferred to ALIS and enter their PIN.
    </p>
    <!-- For step-3 content -->
    <p class="pin-content step3-content hide1" *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Active">
        After the transfer is complete, the customer will return to the Care Portal.
    </p>
    <section *ngIf="this.rootScope.activeCustTab.pinEntryApp.pinError" class="error-wrapper">
        <f-alert variant="error">
            {{this.rootScope.activeCustTab.pinEntryApp.pinError}}
        </f-alert>

    </section>
    <div class="btn-refresh-container flex">
        <div class="btn-controls">
            <f-button text="Create PIN" title="Create PIN"
                [disabled]="!rootScope.isLiveCall && rootScope.activeCustTab.CS_SECURITY_LEVEL==='4'"
                *ngIf="rootScope.activeCustTab.pinEntryApp?.step1Active" type="button"
                (buttonClicked)="authService?.pinCreation()" variant="progressive" class=""></f-button>
            <f-button text="Try Again" title="Try Again" (buttonClicked)="cancelButton()"
                *ngIf="this.rootScope.activeCustTab.pinEntryApp.pinError" type="button" variant="progressive"
                class="hide1">
            </f-button>
            <f-button text="Cancel" title="Cancel" (buttonClicked)="cancelButton()"
                *ngIf="rootScope.activeCustTab.pinEntryApp?.step2Active" type="button" variant="action"
                class="hide1"></f-button>
        </div>
        <!-- Enable to show refresh message  -->
        <div class="refresh-link " *ngIf="rootScope.activeCustTab.pinEntryApp?.step3Active">
            <p> If the Security Level didn’t update as expected, click <button class="btn-alert"
                    (click)="genesysService.getLiveCallStatusForAuthMethod()" [ngClass]="{'disabledLink': rootScope.simulationData?.isSimulationModeActive}" >Refresh</button></p>
        </div>
    </div>
</div>

<!-- No PIN Client Validation Message -->
    <div class="ftu-steps-container" *ngIf="authService?.FTUPanelData?.Validation&&rootScope.activeCustTab.isNoPINClient">
        <f-alert class="error-with-heading alert-info " variant="info">
            <p class="alert-top-heading">Customer Data Validated</p>
            <p>{{alertMSG.NO_PIN_INFO_MSG}}</p>
        </f-alert>
    </div>

    <div *ngIf="hasAccountBalance()">  <strong>Note: </strong> {{proceedWithPinResetMsg}} </div>